import { DriveAndMachineContentModel } from './driveAndMachineContentModel';

export class DriveAndMachineModel {
  public driveAndMachineContentId: number;
  public medicineId: number;
  public driveDescription: string;
  public machineDescription: string;
  public driveAndMachineContent: Array<DriveAndMachineContentModel>;
}